export const deleteGroup = (arr, id) => {
  return arr.filter((item) => item.id !== id)
}
